import React, {useCallback, useContext, useEffect, useReducer, useState} from 'react';
import {Backdrop, CircularProgress, Container, Divider, Fab, Paper, Typography} from "@mui/material";
import {useHistory, useParams} from "react-router-dom";
import clsx from 'clsx';
import Grid from "@mui/material/Grid";
import {FormProvider, useForm} from "react-hook-form";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from '@mui/material/Alert';
import {getTamponeById, updateTampone,} from "../../../../services/TamponiServices";
import {setCloseSnackbar, setOpenSnackbar} from "../../../../services/AppServices";
import {generateQuarantenaV3, generateQuarantenaV5} from "../../../../services/QuaranteneServices";
import {generateIntervistaV2, setIntervista} from "../../../../services/IntervistaServices";
import {getIntervistaApiData, getListaOf} from "../../../../services/utils/IntervistaApiData";
import {initTamponiState, TAMPONI_INITIAL_STATE, TamponiReducer} from "../../../../reducers/TamponiReducer";
import {initIntervistaState, INTERVISTA_INITIAL_STATE, IntervistaReducer} from "../../../../reducers/IntervistaReducer";
import {initQuaranteneState, QUARANTENE_INITIAL_STATE, QuaranteneReducer} from "../../../../reducers/QuaranteneReducer";
import {AnagraficaContext, AppContext} from "../../../../App";
import {BaseStyle} from "../../../../styles/shared/BaseStyle";
import {sintomi} from "../../../../utils/arrays/Generics";
import {bigNoteRegisterNotRequired} from "../../../../utils/RegisterUtils";
import {SegnalazionePositivoGrid} from "../../../contattaci/intervista/SegnalazionePositivoGrid";
import CustomMultiText from "../../../widgets/inputs/CustomMultiText";
import HideAppBar from "../../../widgets/header/HideAppBar";
import {AnagraficaCompleta} from "../../../widgets/common/AnagraficaCompleta";
import { Skeleton } from '@mui/material';
import {updateAnagrafica} from "../../../../services/AnagraficaServices";
import {getAnaGraficaApi} from "../../../../services/utils/TicketApiData";
import {RadioGroupQuestion} from "../../../widgets/inputs/RadioGroupQuestion";
import DiarioPaziente from "../../../widgets/diary/DiarioPaziente";
import {amber, blue, green, purple, red} from "@mui/material/colors";
import DoneOutlineTwoToneIcon from "@mui/icons-material/DoneOutlineTwoTone";
import AssignmentTurnedInTwoToneIcon from '@mui/icons-material/AssignmentTurnedInTwoTone';
import {InfoLavorativeGrid} from "./content/InfoLavorativeGrid";
import Button from "@mui/material/Button";
import CallEndTwoToneIcon from '@mui/icons-material/CallEndTwoTone';
import Tooltip from "@mui/material/Tooltip";
import QueueTwoToneIcon from '@mui/icons-material/QueueTwoTone';


const IntervistaTamponeCasoIndice = () => {
	const classes = BaseStyle();
	let history = useHistory();
	const methods = useForm({
		mode: "onChange",
	});
	
	const [submit, setSubmit] = useState(false);
	const [submitQuarantena, setSubmitQuarantena] = useState(false);
	const [submitUpdate, setSubmitUpdate] = useState(false);
	const [submitAnagrafica, setSubmitAnagrafica] = useState(false);
	const appContext = useContext(AppContext);
	const anagraficaContext = useContext(AnagraficaContext);
	const [tamponiState, tamponiDispatch] = useReducer(TamponiReducer, TAMPONI_INITIAL_STATE, initTamponiState);
	const [intervistaState, intervistaDispatch] = useReducer(IntervistaReducer, INTERVISTA_INITIAL_STATE, initIntervistaState);
	const [quarantenaState, quarantenaDispatch] = useReducer(QuaranteneReducer, QUARANTENE_INITIAL_STATE, initQuaranteneState);
	const [startGetTampone, setStartGetTampone] = useState(true);
	const [backOk, setBackOk] = useState(false);
	let {idTampone} = useParams();
	
	const backFunction = () => {
		if (!tamponiState.loadingGetTampone && tamponiState.errorGetTampone === "") {
			setSubmitUpdate(true);
			updateTampone({...tamponiState.tampone, active: false}, tamponiDispatch);
		}
	}
	
	const segnaGestito = () => {
		if (!tamponiState.loadingGetTampone && tamponiState.errorGetTampone === "") {
			setSubmitUpdate(true);
			updateTampone({...tamponiState.tampone, active: false, stato: "Gestito"}, tamponiDispatch);
		}
	}
	
	const segnaDaGestire = () => {
		if (!tamponiState.loadingGetTampone && tamponiState.errorGetTampone === "") {
			setSubmitUpdate(true);
			updateTampone({...tamponiState.tampone, active: false, stato: "Da gestire"}, tamponiDispatch);
		}
	}
	
	const nonRisponde = () => {
		if (!tamponiState.loadingGetTampone && tamponiState.errorGetTampone === "") {
			setSubmitUpdate(true);
			updateTampone({...tamponiState.tampone, active: false, stato: "Preso in carico"}, tamponiDispatch);
		}
	}
	
	const handleCloseSnack = useCallback(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch]);
	
	const onSubmit = useCallback((data) => {
		setSubmit(true);
		updateAnagrafica(getAnaGraficaApi({...tamponiState.tampone.soggetto, ...data.soggetto}), tamponiState.tampone.soggetto?.idSoggetto, anagraficaContext.dispatch);
		setIntervista(data, intervistaDispatch);
		generateIntervistaV2({
			...getIntervistaApiData(data),
			note: JSON.stringify(data.contatti),
			tipoContatto: "Caso indice",
			soggetto: {...tamponiState.tampone.soggetto, ...data.soggetto},
			type: "OPR",
			tamponeId: tamponiState.tampone.id,
		}, intervistaDispatch, true)
	}, [tamponiState.tampone, intervistaDispatch, anagraficaContext.dispatch])
	
	const creaIsolamento = () => {
		setSubmitQuarantena(true);
		generateQuarantenaV5(tamponiState.tampone.soggetto, {
			...tamponiState.tampone, ...methods.getValues(),
			idTampone: idTampone
		}, quarantenaDispatch);
	}
	
	const aggiornaAnagrafica = useCallback(() => {
		setSubmitAnagrafica(true);
		updateAnagrafica(getAnaGraficaApi({...tamponiState.tampone.soggetto, ...methods.getValues().soggetto}), tamponiState.tampone.soggetto?.idSoggetto, anagraficaContext.dispatch);
	}, [tamponiState.tampone.soggetto, methods, anagraficaContext.dispatch])
	
	useEffect(() => {
		if (submitAnagrafica && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica === "") {
			setSubmitAnagrafica(false);
			setOpenSnackbar("success", "Anagrafica aggiornata correttamente!", appContext.dispatch);
		} else if (submitAnagrafica && !anagraficaContext.state.loadingUpdateAnagrafica && anagraficaContext.state.errorUpdateAnagrafica !== "") {
			setSubmitAnagrafica(false);
			setOpenSnackbar("error", anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch);
		}
	}, [submitAnagrafica, anagraficaContext.state.loadingUpdateAnagrafica, anagraficaContext.state.errorUpdateAnagrafica, appContext.dispatch])
	
	useEffect(() => {
		if (submitUpdate && !tamponiState.loadingUpdateTampone && tamponiState.errorUpdateTampone === "") {
			setSubmitUpdate(false);
			setBackOk(false);
			history.goBack();
		} else if (submitUpdate && !tamponiState.loadingUpdateTampone && tamponiState.errorUpdateTampone !== "") {
			setSubmitUpdate(false);
		}
	}, [submitUpdate, tamponiState.loadingUpdateTampone, tamponiState.errorUpdateTampone, history])
	
	useEffect(() => {
		if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista === "") {
			setSubmit(false);
			setSubmitQuarantena(true);
			let score = Math.round(getListaOf(sintomi, intervistaState.intervista)?.split(",")?.length * 4 / 11)
			generateQuarantenaV3(tamponiState.tampone.soggetto?.idSoggetto, methods.getValues(), intervistaState.intervista.id, score, "PAZ_ZERO", idTampone, quarantenaDispatch, "", "");
		} else if (submit && !intervistaState.loadingAddIntervista && intervistaState.errorAddIntervista !== "") {
			setSubmit(false);
			setOpenSnackbar("error", intervistaState.errorAddIntervista, appContext.dispatch);
		}
	}, [submit, intervistaState.loadingAddIntervista, intervistaState.errorAddIntervista, tamponiState.tampone,
		quarantenaDispatch, intervistaState.intervista, appContext.dispatch, methods, idTampone])
	
	useEffect(() => {
		if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena === "") {
			setOpenSnackbar("success", "Ordinanza creata correttamente! Tra 2 secondi verrai rimandato indietro", appContext.dispatch);
			setTimeout(() => {
				history.goBack();
			}, 2000)
		} else if (submitQuarantena && !quarantenaState.loadingGenerateQuarantena && quarantenaState.errorGenerateQuarantena !== "") {
			setSubmitQuarantena(false);
			setOpenSnackbar("error", quarantenaState.errorGenerateQuarantena, appContext.dispatch);
		}
	}, [submitQuarantena, quarantenaState.loadingGenerateQuarantena, quarantenaState.errorGenerateQuarantena, appContext.dispatch, history])
	
	useEffect(() => {
		setCloseSnackbar(appContext.dispatch);
	}, [appContext.dispatch])
	
	useEffect(() => {
		setStartGetTampone(true);
		getTamponeById(idTampone, tamponiDispatch)
	}, [idTampone, tamponiDispatch])
	
	useEffect(() => {
		if (startGetTampone && !tamponiState.loadingGetTampone && tamponiState.errorGetTampone === "") {
			setStartGetTampone(false);
			methods.reset({soggetto: tamponiState.tampone.soggetto});
		} else if (startGetTampone && !tamponiState.loadingGetTampone && tamponiState.errorGetTampone !== "") {
			setStartGetTampone(false);
		}
	}, [startGetTampone, tamponiState.loadingGetTampone, tamponiState.errorGetTampone, methods, tamponiState.tampone])
	
	useEffect(() => {
		document.body.style = `background-image: none`;
	}, []);
	
	return (
		<React.Fragment>
			<Backdrop open={submit} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
			<Backdrop open={startGetTampone} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
			<Backdrop open={submitQuarantena} className={classes.backdrop}>
				<CircularProgress color={"inherit"}/>
			</Backdrop>
			<main className={classes.main}>
				<HideAppBar title={"Intervista epidemiologica"} back={true} backOk={backOk} useBackOk={true}
				            backFunction={backFunction}/>
				
				<Container maxWidth={"xl"} component={"article"} style={{paddingTop: 12}}>
					
					<Grid container spacing={3}>
						
						<Grid item xs={12} md={7}
						      style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden"}}
						>
							<Paper className={clsx(classes.roundBorder, classes.padding2)}>
								
								<form onSubmit={methods.handleSubmit(onSubmit)}>
									<FormProvider {...methods}>
										
										<Grid container spacing={3}>
											<Grid item xs={12}>
												<Typography color={"primary"} variant={"h4"}>
													<b>Caso indice</b>
												</Typography>
												<Typography color={"textSecondary"}>
													Clicca sul bottone dettaglio paziente per andare a visualizzare tutte le informazioni del
													paziente
													in oggetto (diario, ticket, interviste, quarantene o isolamenti, tamponi, prenotazioni
													tamponi,
													vaccini, ...) e / o per aggiornare la sua anagrafica.
												</Typography>
											</Grid>
											<Grid item xs={12}>
												<Divider/>
											</Grid>
											{
												tamponiState.loadingGetTampone ? <Skeleton/> :
													tamponiState.errorGetTampone !== "" ? "Error" :
														<AnagraficaCompleta anagrafica={tamponiState.tampone.soggetto} name={"soggetto."}
														                    intro={"false"} moreInfo={true} classes={classes} domReq={true}/>
											}
											<Grid item xs={12} className={classes.flexRight}>
												<Button variant={"contained"} color={"primary"} disableElevation disabled={submitAnagrafica}
												        style={{borderRadius: 24}} onClick={aggiornaAnagrafica}>
													<b>Aggiorna anagrafica</b>
												</Button>
											</Grid>
											<Grid item xs={12}>
												<Divider/>
											</Grid>
											
											<InfoLavorativeGrid/>
											
											{
												tamponiState.loadingGetTampone ? <Skeleton/> :
													tamponiState.errorGetTampone !== "" ? "Error" :
														<SegnalazionePositivoGrid showAlert={false}
														                          dataEsito={new Date(tamponiState.tampone?.dataEsito)}/>
											}
											<Grid item xs={12}>
												<RadioGroupQuestion
													question={"Vuole effettuare il tampone tramite l'Asl Città di Torino?"}
													control={methods.control}
													autoFocus={true}
													defaultValue={""}
													rules={{required: true}}
													name={"protocollo"}
													error={methods.errors["protocollo"]}
												/>
												<Typography color={"textSecondary"}>
													In caso lei decida di effettuare il tampone per conto suo verrà
													solamente monitorato per quelli
													che sono i suoi sintomi giornalieri; nel caso lei decida di effettuare il tampone tramite
													l'Asl le
													verrà prenotato un tampone di controllo al 10° o 7° giorno (a seconda della tua situazione
													vaccini
													/ guarigioni) e verrà contattato il giorno prima.
												</Typography>
											</Grid>
											
											<Grid item xs={12}>
												<CustomMultiText
													inputRef={methods.register(bigNoteRegisterNotRequired)}
													name={"noteQuarantena"}
													label={"Note particolari da indicare"}
													autoFocus={false}
													error={methods.errors["noteQuarantena"]}
													rows={10}
												/>
											</Grid>
											
											{/*<Grid item xs={12} style={{display: "flex", justifyContent: "center"}}>
											 <Button variant={"contained"} color={"primary"} disableElevation className={classes.roundButton}
											 onClick={methods.handleSubmit(onSubmit)} disabled={submit}
											 style={{fontSize: 18, borderRadius: 24}}>
											 <b>Compila intervista</b>
											 </Button>
											 </Grid>*/}
										
										</Grid>
									</FormProvider>
								</form>
							
							</Paper>
						</Grid>
						
						<Grid item xs={12} md={5}>
							<Grid container spacing={3}
							      style={{maxHeight: "92vh", overflowY: "auto", overflowX: "hidden", paddingBottom: 50}}>
								<Grid item xs={12}>
									{
										tamponiState.loadingGetTampone ? <Skeleton/> :
											tamponiState.errorGetTampone !== "" ? "Error" :
												<DiarioPaziente idSoggetto={tamponiState.tampone.soggetto?.idSoggetto}/>
									}
								</Grid>
							</Grid>
						</Grid>
					
					</Grid>
				
				</Container>
			</main>
			
			<div className={classes.fabContainer}>
				<Tooltip title={"Crea l'isolamento senza intervista"}>
					<Fab
						variant={"extended"}
						type={"submit"}
						style={{
							backgroundColor: blue[800],
							color: "#FFF"
						}}
						className={clsx(classes.fab, classes.greenFab)}
						onClick={creaIsolamento} disabled={submit}
					>
						<React.Fragment>
							<QueueTwoToneIcon className={classes.extendedIconFab}/>
							Crea provvedimento
						</React.Fragment>
					</Fab>
				</Tooltip>
				<Tooltip title={"Segna il tampone come preso in carico"}>
					<Fab
						variant={"extended"}
						type={"submit"}
						style={{
							backgroundColor: purple[600],
							color: "#FFF"
						}}
						className={clsx(classes.fab, classes.greenFab)}
						onClick={nonRisponde} disabled={submit}
					>
						<React.Fragment>
							<CallEndTwoToneIcon className={classes.extendedIconFab}/>
							Non risponde
						</React.Fragment>
					</Fab>
				</Tooltip>
				<Fab
					variant={"extended"}
					type={"submit"}
					style={{
						backgroundColor: red[600],
						color: "#FFF"
					}}
					className={clsx(classes.fab, classes.greenFab)}
					onClick={segnaDaGestire} disabled={submit}
				>
					<DoneOutlineTwoToneIcon className={classes.extendedIconFab}/>
					Segna da gestire
				</Fab>
				<Fab
					variant={"extended"}
					type={"submit"}
					style={{
						backgroundColor: green[600],
						color: "#FFF"
					}}
					className={clsx(classes.fab, classes.greenFab)}
					onClick={segnaGestito} disabled={submit}
				>
					<DoneOutlineTwoToneIcon className={classes.extendedIconFab}/>
					Segna gestito
				</Fab>
				<Fab
					variant={"extended"}
					type={"submit"}
					style={{
						backgroundColor: amber[500],
						color: "#000"
					}}
					className={clsx(classes.fab, classes.greenFab)}
					onClick={methods.handleSubmit(onSubmit)} disabled={submit}
				>
					<AssignmentTurnedInTwoToneIcon className={classes.extendedIconFab}/>
					Compila intervista
				</Fab>
			</div>
			
			<Snackbar open={appContext.state.open} autoHideDuration={3000} onClose={handleCloseSnack}>
				<SnackAlert style={{borderRadius: 28}} onClose={handleCloseSnack}
				            severity={appContext.state.severity}>
					{appContext.state.message}
				</SnackAlert>
			</Snackbar>
		</React.Fragment>
	);
};

function SnackAlert(props) {
	return <MuiAlert elevation={16} variant="filled" {...props} />;
}

export default React.memo(IntervistaTamponeCasoIndice);
